import { render, staticRenderFns } from "./ProductEditAppleCare.vue?vue&type=template&id=608f25ab&"
import script from "./ProductEditAppleCare.vue?vue&type=script&lang=js&"
export * from "./ProductEditAppleCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports